export default __webpack_public_path__ + "static/media/Starfish2.0924dcf6.png";